// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"117":"bd7b3ebd8ce1a216","746":"7dec6c30dce033ef"}[chunkId] + ".js";
};